import MuseumsManager from "./MuseumsManager";
export default function Cities() { return <MuseumsManager kind="city" />; }
